import type { UserRole } from '@/entities/user/model/userSchema';

export const APP_ROLE_OPTIONS: { value: UserRole; label: string }[] = [
  { value: 'admin', label: 'Администратор' },
  { value: 'ot_specialist', label: 'Специалист по ОТ' },
  { value: 'department_head', label: 'Руководитель подразделения' },
  { value: 'master', label: 'Мастер' },
  { value: 'viewer', label: 'Просмотр' },
  { value: 'employee', label: 'Обычный сотрудник' },
];

const labelByCode = Object.fromEntries(APP_ROLE_OPTIONS.map((o) => [o.value, o.label])) as Record<UserRole, string>;

const badgeByCode: Record<UserRole, string> = {
  admin: 'default',
  ot_specialist: 'err',
  department_head: 'info',
  master: 'warn',
  viewer: 'default',
  employee: 'ok',
};

export function roleLabelFromCode(code: UserRole): string {
  return labelByCode[code];
}

export function roleBadgeFromCode(code: UserRole): string {
  return badgeByCode[code];
}

export function displayRoleName(record: { roleCode: UserRole }): string {
  return roleLabelFromCode(record.roleCode);
}
